var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _circle3, _rect9, _circle4, _ellipse, _path2, _path3, _path4, _circle5, _path5, _path6, _polygon, _rect10, _path7, _path8, _circle6, _path9, _path10, _path11, _path12, _rect11, _rect12, _rect13, _path13, _rect14, _rect15, _rect16, _path14, _rect17, _rect18, _rect19, _path15, _rect20, _rect21, _rect22, _path16, _path17, _path18, _circle7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawDesignFeedbackDexe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aacf679f-7774-484d-919c-70dbfadaa690",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1114.24868,
    height: 608.51147,
    viewBox: "0 0 1114.24868 608.51147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "design_feedback") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 356.34665,
    y: 63.16584,
    width: 757.90203,
    height: 492.40665,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 333.37992,
    y: 60.40984,
    width: 57.87616,
    height: 497,
    fill: "#d0cde1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 502.41504,
    y: 197.29154,
    width: 151.58041,
    height: 1.83734,
    fill: "#d0cde1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1042.2907,609.44985H833.75281V414.692H1042.2907Zm-206.70055-1.83734h204.86321V416.52933H835.59015Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#d0cde1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 937.1028,
    y: 370.69956,
    width: 1.83791,
    height: 282.74272,
    transform: "translate(-119.2358 702.67589) rotate(-46.97487)",
    fill: "#d0cde1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 796.65039,
    y: 511.15197,
    width: 282.74272,
    height: 1.83791,
    transform: "translate(-140.00762 631.95463) rotate(-43.02234)",
    fill: "#d0cde1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 502.41504,
    y: 332.3359,
    width: 214.04991,
    height: 1.83734,
    fill: "#d0cde1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 502.41504,
    y: 365.40799,
    width: 214.04991,
    height: 1.83734,
    fill: "#d0cde1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 502.41504,
    y: 398.48008,
    width: 214.04991,
    height: 1.83734,
    fill: "#d0cde1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 680.7075,
    cy: 19.40984,
    r: 19.40984,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.29767,
    cy: 19.40984,
    r: 19.40984,
    fill: "#6c63ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 789.88783,
    cy: 19.40984,
    r: 19.40984,
    fill: "#d0cde1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 606.19624,
    width: 652.89371,
    height: 2.31523,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.69381,
    cy: 213.20187,
    r: 12.77215,
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 219.66396,
    cy: 171.10109,
    rx: 36.65094,
    ry: 40.20861,
    fill: "#2f2e41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M236.75207,489.7424l-.94608,4.73043s-2.83826,2.83825-1.41913,4.25738.94609,8.04172.94609,8.04172l-2.83826,18.44866L215.9382,599.96131s-21.76,14.19128-38.78949,42.10079-17.50257,35.00514-17.50257,35.00514l18.9217,8.04173,47.30425-57.23815s13.2452-8.04172,17.97562-15.13736,34.05906-80.41723,34.05906-80.41723l16.55649,76.63289s-.94608,27.90951,3.3113,45.88512a192.5196,192.5196,0,0,1,4.73042,34.53211l22.233-2.36521s-1.41912-67.172-3.78434-74.26768c0,0,9.9339-81.83636-9.93389-114.47629l-11.82606-47.7773-19.86779-.94608Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#2f2e41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.35218,683.2168l-23.65212-14.66432-10.88,20.81387s-24.12517,14.66432-18.9217,25.54429,9.93389,13.71824,9.93389,13.71824l3.3113-1.41913,6.14955,11.353s16.08345,23.17908,42.10079,11.353a9.50823,9.50823,0,0,0,0-11.353c-4.25739-6.14955-15.13737-19.39474-15.13737-19.39474Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M327.1032,683.68984,301.08586,685.582l2.83825,21.28691s-12.2991,30.27472-3.78434,32.63994a124.73739,124.73739,0,0,0,18.44866,3.31129l.94609-3.31129s36.42427,19.86778,49.66946,5.20346c0,0,2.83826-10.40693-5.20347-13.71823s-23.65212-10.40693-25.54429-14.19128S327.1032,683.68984,327.1032,683.68984Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 220.83984,
    cy: 177.48716,
    r: 22.70604,
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M246.686,336.94966s2.83825,18.44866-11.353,25.5443,37.37036,15.6104,37.37036,15.6104-8.04173-12.2991-6.6226-16.55648,8.51477-21.28692,8.51477-21.28692Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.90163,362.967s-13.71824-8.04172-18.44866-4.25738-6.14956,119.67976,10.88,124.41019l.473,6.14955s-6.14956,2.83825-.473,2.83825,32.16689-19.39474,33.113-26.49038,28.38255-8.51476,28.38255-8.51476,7.09564,30.27472,9.46085,29.32863,2.36522-21.28691,1.41913-24.12517,10.88-11.82606,7.56868-17.50257-12.2991-25.07125-12.2991-25.07125S303.92411,407.433,291.152,396.08c0,0-3.7325-21.13035-20.55143-21.44515S242.90163,362.967,242.90163,362.967Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#575a89"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "198.233 149.855 198.233 175.809 204.243 175.809 211.892 167.613 210.868 175.809 237.436 175.809 235.797 167.613 239.075 175.809 243.309 175.809 243.309 149.855 198.233 149.855",
    fill: "#2f2e41"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 57.8143,
    y: 382.40984,
    width: 196,
    height: 179,
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M216.74817,621.36059c-16.52316,26.97544-10.8384,60.53-10.8384,60.53s32.4741-10.18126,48.99726-37.15669,10.8384-60.53,10.8384-60.53S233.27133,594.38516,216.74817,621.36059Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.23545,682.11333l-.93946-.14881c-.33973-.05387-34.155-5.65668-54.40673-29.887-20.25189-24.23109-19.76452-58.50417-19.75789-58.84757l.02016-.95077.93947.1488c.33972.05387,34.155,5.65668,54.40685,29.88778h0c20.25176,24.23029,19.7644,58.50336,19.75776,58.84676Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#d0cde1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.06511,
    cy: 430.48113,
    r: 18.2567,
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M207.42344,478.38938,213.1,520.49017s-3.3113,36.89731,9.46085,37.37036,4.73042-37.84341,4.73042-37.84341l-1.41913-38.31644S215.46516,464.67115,207.42344,478.38938Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M228.71035,361.54788s-3.3113-8.98781-10.40694-1.89217S205.05822,385.2,205.05822,396.553s1.41913,77.10594,1.41913,77.10594-7.56868,2.83825-2.36521,7.09563,12.2991-2.36521,12.2991-2.36521,9.46085,6.6226,10.40694,6.6226.473-8.04173.473-8.04173,4.73043-12.2991,3.78434-21.76S228.71035,361.54788,228.71035,361.54788Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#575a89"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.2907,317.31307H544.372V283.32231H1042.2907Zm-496.08133-1.83734h494.244V285.15965h-494.244Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#d0cde1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M152.69,577.1541h-49c3.78254-15.22234,3.32618-31.68972,0-49h49Q142.40126,552.65411,152.69,577.1541Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#d0cde1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 68.23854,
    y: 392.80378,
    width: 29.69697,
    height: 5.93939,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 68.23854,
    y: 404.68256,
    width: 29.69697,
    height: 5.93939,
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 68.23854,
    y: 416.56135,
    width: 29.69697,
    height: 5.93939,
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M593.69,385.1541h-49c3.78254-15.22234,3.32618-31.68972,0-49h49Q583.40127,360.65411,593.69,385.1541Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#d0cde1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 509.23854,
    y: 200.80378,
    width: 29.69697,
    height: 5.93939,
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 509.23854,
    y: 212.68256,
    width: 29.69697,
    height: 5.93939,
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 509.23854,
    y: 224.56135,
    width: 29.69697,
    height: 5.93939,
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M962.69,459.1541h-49c3.78254-15.22234,3.32618-31.68972,0-49h49Q952.40127,434.65411,962.69,459.1541Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#d0cde1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 878.23854,
    y: 274.80378,
    width: 29.69697,
    height: 5.93939,
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 878.23854,
    y: 286.68256,
    width: 29.69697,
    height: 5.93939,
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 878.23854,
    y: 298.56135,
    width: 29.69697,
    height: 5.93939,
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.69,354.1541h-49c3.78254-15.22234,3.32618-31.68972,0-49h49Q1015.40127,329.65411,1025.69,354.1541Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#d0cde1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 941.23854,
    y: 169.80378,
    width: 29.69697,
    height: 5.93939,
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 941.23854,
    y: 181.68256,
    width: 29.69697,
    height: 5.93939,
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 941.23854,
    y: 193.56135,
    width: 29.69697,
    height: 5.93939,
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M418.19387,409.6541h-26v-26h26Zm-24-2h22v-22h-22Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M418.69,467.6541h-26v-26h26Zm-24-2h22v-22h-22Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M419.18605,525.6541h-26v-26h26Zm-24-2h22v-22h-22Z",
    transform: "translate(-42.87566 -145.74427)",
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 350.8143,
    cy: 354.40984,
    r: 8,
    fill: "#6c63ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawDesignFeedbackDexe);
export default __webpack_public_path__ + "static/media/undraw_design_feedback_dexe.10688b28.svg";
export { ForwardRef as ReactComponent };